import { CompanyUiModel } from '../ui-models/company.ui-model';
import { CompanyModel } from '../models/company.model';

function mapToUI(companyData: CompanyModel): CompanyUiModel {
  return {
    id: companyData.id || '',
    name: companyData.name,
    contactPersonName: companyData.contactPersonName,
    contactPersonEmail: companyData.contactPersonEmail,
    contactPersonPhoneNumber: companyData.contactPersonPhoneNumber,
    createdAt: companyData.createdAt,
    createdById: companyData.createdById,
    createdByUsername: companyData.createdByUsername,
    modifiedAt: companyData.modifiedAt,
    modifiedById: companyData.modifiedById,
    modifiedByUsername: companyData.modifiedByUsername
  };
}

function mapToModel(companyData: CompanyUiModel): CompanyModel {
  return {
    id: companyData.id,
    name: companyData.name,
    contactPersonName: companyData.contactPersonName,
    contactPersonEmail: companyData.contactPersonEmail,
    contactPersonPhoneNumber: companyData.contactPersonPhoneNumber,
    createdAt: companyData.createdAt,
    createdById: companyData.createdById,
    createdByUsername: companyData.createdByUsername,
    modifiedAt: companyData.modifiedAt,
    modifiedById: companyData.modifiedById,
    modifiedByUsername: companyData.modifiedByUsername
  };
}

function mapToUIList(companiesList: CompanyModel[]): CompanyUiModel[] {
  return companiesList.map(mapToUI);
}

function mapToModelList(companiesList: CompanyUiModel[]): CompanyModel[] {
  return companiesList.map(mapToModel);
}

export default {
  mapToUI,
  mapToModel,
  mapToUIList,
  mapToModelList
};
